import React from 'react';

import type { SelectedDataLakesContextValue } from 'data-lake/contexts/SelectedDataLakesContext';
import SelectedDataLakesContext from 'data-lake/contexts/SelectedDataLakesContext';
import { INTERNAL_DATA_LAKE_INFO } from 'data-lake/Constants';

const contextValue: SelectedDataLakesContextValue = {
  selectedDataLake: INTERNAL_DATA_LAKE_INFO,
};

const SelectedInternalDataLakeProvider = ({ children = undefined }: React.PropsWithChildren) => (
  <SelectedDataLakesContext.Provider value={contextValue}>{children}</SelectedDataLakesContext.Provider>
);

export default SelectedInternalDataLakeProvider;
